export default "__VITE_ASSET__15442787__"